import { useContext, useEffect } from "preact/hooks";

import { Tag, Modal, Loader } from "../../components";
import { Context } from "../Context";
const Services = require("./all_services.json");

import {
  handleDropdownClose,
  handleDropdownOpen,
  isMobileScreen,
} from "../../helpers";
import { useFetchTags } from "../../hooks";

import style from "./TagsFilter.css";
import { Fragment } from "preact";
import { createPortal } from 'react-dom' 


const TagsFilter = ({
  reqParams,
  selectedTags,
  onClearAllTags,
  onTagSelected,
  selectedServices,
  onServiceSelected,
  category
}) => {
  const [context, setContext] = useContext(Context);
  const { loading, tags } = useFetchTags(reqParams);

  // useEffect(() => {
  //   window.addEventListener("popstate", handlePop);

  //   return () => {
  //     document.removeEventListener("popstate", handlePop);
  //   };
  // }, []);

  // const handlePop = (event) => {
  //   if (window.location.search.indexOf("tagOpen") >= 0) {
  //     setContext({ ...context, filterOpen: "tagOpen" });
  //   } else {
  //     if (window.location.search.indexOf("tagOpen") < 0) {
  //       setContext({ ...context, filterOpen: "" });
  //     }
  //   }
  // };

  const isInSelected = (name) => {
    return selectedTags.includes(name);
  };
  const isInSelectedServices = (name) => {
    return selectedServices.includes(name);
  };

  const mergeTags = (a, b) => {
    return a.concat(b.filter((item) => a.indexOf(item) < 0));
  };

  const handleTagModalOpen = () => {
    handleDropdownOpen("tagOpen");
    setContext({
      filterOpen: "tagOpen",
    });
  };

  const handleTagModalClose = () => {
    handleDropdownClose("tagOpen");
    setContext({
      filterOpen: "",
    });
  };

  const renderTags = () => {
    if (loading) return <Loader />;
    const combinedTags = mergeTags(selectedTags, tags);

    return combinedTags.map((tagName, index) => {
      return (
        <Tag
          key={index}
          text={tagName}
          onClick={() => onTagSelected(tagName)}
          selected={isInSelected(tagName)}
        />
      );
    });
  };

  const checkDisabled = () => {
    if (selectedTags.length === 0) return style.disableClear;
  };

  const conditionalRenderSelectedTags = () => {
    if (selectedTags.length > 0) return "(" + selectedTags.length + ")";
    return "";
  };


  const conditionalRenderServices = () => {
    let servicesAvailable = Services[category] ? Services[category].filter(s => s.type == "checkbox") : []
    servicesAvailable = Object.keys(servicesAvailable).map((key) => servicesAvailable[key]);

    return servicesAvailable.map(s => { 
      return (
        <Fragment>
          <h4 class={style.serviceHeader}>{s.title}</h4>
          <div class={style.serviceContainer}>
            {s.options.map(o => { return (
            <div class={style.serviceOption} onClick={() => onServiceSelected(o.key)} >
                <input type="checkbox" {... isInSelectedServices(o.key) ? {checked:true}: {} } id={o.key} name={o.key} value={o.key} />
                <label for={o.key}>{o.title}</label>
              </div>
              )
            })}
          </div>
        </Fragment>
      )
    })
  };

  const conditionalRenderModal = () => {
    if (context.filterOpen === "tagOpen") {
      return (
	      createPortal(
          <Modal
            headerText={"Merkmale " + conditionalRenderSelectedTags()}
            onClose={handleTagModalClose}
          >
            <div class={style.modalContainer}>
              <div class={style.tagContainer}>
                { conditionalRenderServices()}
                <h4 class={style.serviceHeader}>Weitere Merkmale</h4>
                <div class={style.tagContent}>{renderTags()}</div>
              </div>
            </div>
            <div class={style.footer}>
              <span
                class={style.clearAllTags + " " + checkDisabled()}
                onClick={() => {
                  onClearAllTags();
                  handleTagModalClose();
                }}
              >
                Löschen
              </span>
              <button style={{ color: "white" }} onClick={handleTagModalClose}>
                Speichern
              </button>
            </div>
          </Modal>
	      , document.body)
      );
    }
    return null;
  };

  const getText = () => {
    let text = "Merkmale";
    if (selectedTags.length !== 0) {
      text = text + " (" + selectedTags.length + ")";
    }
    return text;
  };

  return (
    <Fragment>
      <Tag
        id="mapTagsFilter"
        text={getText()}
        selected={selectedTags && selectedTags.length > 0}
        onClick={handleTagModalOpen}
        shouldTruncate={isMobileScreen()}
      />

      {conditionalRenderModal()}
    </Fragment>
  );
};

export { TagsFilter };
